import { render, staticRenderFns } from "./TooltipIcon.vue?vue&type=template&id=2e50fa4d&scoped=true"
import script from "./TooltipIcon.vue?vue&type=script&lang=ts"
export * from "./TooltipIcon.vue?vue&type=script&lang=ts"
import style0 from "./TooltipIcon.vue?vue&type=style&index=0&id=2e50fa4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50fa4d",
  null
  
)

export default component.exports